'use client';

import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';
import { humanizeMasterpassError } from '@/lib/masterpassError';

export default function CheckoutBPaymentErrorDialog({
  message,
  onClose,
}: {
  message: string | null;
  onClose: () => void;
}) {
  const detail = humanizeMasterpassError({ messages: [message || ''] });

  return (
    <Dialog
      open={Boolean(message)}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent
        overlayClassName="z-[80]"
        className="z-[80] max-w-md rounded-2xl border-0 bg-white p-6 shadow-xl"
      >
        <div className="flex justify-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-red-500 text-white">
            <svg
              className="h-8 w-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.4" d="M12 8v5" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.4" d="M12 17h.01" />
            </svg>
          </div>
        </div>
        <DialogTitle className="text-center text-[28px] font-bold text-hzc_beige_900">
          Üzgünüz!
        </DialogTitle>
        <DialogDescription className="text-center text-base text-hzc_beige_900">
          {detail}
        </DialogDescription>
        <div className="flex justify-center pt-2">
          <Button
            type="button"
            className="h-12 rounded-full bg-hzc_purple_500 px-10 font-bold text-white hover:scale-105 hover:bg-hzc_purple_500"
            onClick={onClose}
          >
            Tamam
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
